import api from "./axiosInstance";

const TOKEN_KEY = "token";
const USER_KEY  = "user";

const authService = {
  async login(username, password, force = false) {
    try {
      const response = await api.post("/auth/login", { username, password, force });
      const data = response.data;

      if (data.token) {
        sessionStorage.setItem(TOKEN_KEY, data.token);
        if (data.currentUser) {
          sessionStorage.setItem(USER_KEY, JSON.stringify(data.currentUser));
        }
        return { ...data, status: "Success" };
      }

      if (data.status === "SessionConflict") {
        return data;
      }

      throw new Error(data.error || "Login failed");
    } catch (error) {
      throw new Error(error.message || "Login failed. Please try again.");
    }
  },

  async caGlobalLogin(username, token) {
    try {
      const response = await api.post("/auth/caglobal", { Username: username, Token:token });
      const data = response.data;

      if (data.token) {
        sessionStorage.setItem(TOKEN_KEY, data.token);
        if (data.currentUser) {
          sessionStorage.setItem(USER_KEY, JSON.stringify(data.currentUser));
        }
        return { ...data, status: "Success" };
      }

      throw Object.assign(new Error(data.error || "Automatic sign-in failed"), {
        status: data.status,
      });
    } catch (error) {
      // axios interceptor rejects with { message, status (HTTP code), raw }
      const httpStatus   = error.status;          // numeric HTTP status code
      const backendBody  = error.raw?.response?.data;
      const backendStatus = backendBody?.status;  // e.g. "NotFound", "InvalidToken"
      const message      = backendBody?.error || error.message || "Automatic sign-in failed";

      // Re-throw with the backend's named status so SsoSignIn.jsx can branch cleanly
      throw Object.assign(new Error(message), {
        status: backendStatus || (httpStatus === 404 ? "NotFound" : "Error"),
        httpStatus,
      });
    }
  },

  async caGlobalCreateAccount(username, token) {
    try {
      await api.post("/auth/caglobal/create", { username, token });
      return { success: true };
    } catch (error) {
      const backendBody = error.raw?.response?.data;
      return {
        success: false,
        status: backendBody?.status,
        error: backendBody?.error || error.message || "Account creation failed",
      };
    }
  },

  logout() {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  },

  getCurrentUser() {
    const userJson = sessionStorage.getItem(USER_KEY);
    return userJson ? JSON.parse(userJson) : null;
  },

  getToken() {
    return sessionStorage.getItem(TOKEN_KEY);
  },

  isAuthenticated() {
    return !!this.getToken();
  },
};

export default authService;